import { Badge } from 'antd';
import {
  Box,
  Colors,
  IcAddress,
  IcEdit,
  IcInStore,
  IcPhone,
  Text,
} from 'basic-ui-lib';
import { IDetailStore } from 'modules/store/interfaces/api';
import { NewStoreModal, useNewStoreModalRef } from 'modules/store/screens/Create';
import styled from 'styled-components';
import { formatPhone } from 'utils/formatPhone';

interface HeaderProps {
  data: IDetailStore;
}
const Header = ({ data }: HeaderProps) => {
  const editStoreModalRef = useNewStoreModalRef();
  return (
    <StoreHeader>
      <StoreInfo>
        <StoreIconWrapper>
          <IcInStore fill={Colors.primary[6]} width={32} height={32} />
        </StoreIconWrapper>

        <StoreMainInfo>
          <StoreNameRow>
            <Text title_h5 semibold>
              {data?.businessName}
            </Text>

            <EditButton type='button' onClick={() => editStoreModalRef.current?.open(data)}>
              <IcEdit fill={Colors.primary[6]} width={20} height={20} />
            </EditButton>
          </StoreNameRow>

          <Box
            backgroundColor={Colors.secondary[1]}
            display='flex'
            padding='2px 8px'
            borderRadius='100px'
            alignItems='center'
            gap={4}
            width='fit-content'
          >
            <Badge dot color={Colors.secondary[5]} />
            <Text body_1 medium color='secondary.5'>
              Active
            </Text>
          </Box>
        </StoreMainInfo>
      </StoreInfo>

      <StoreContact>
        <ContactItem>
          <IcPhone />

          <Text body_1 medium>
            {formatPhone(data?.phone)}
          </Text>
        </ContactItem>

        <ContactDivider />

        <ContactItem>
          <IcAddress />

          <Address>
            <Text body_1 medium>
              {data?.address}
            </Text>
            <Text body_1 medium>
              {data?.city}, {data?.state} {data?.zip}
            </Text>
          </Address>
        </ContactItem>
      </StoreContact>
       <NewStoreModal ref={editStoreModalRef} />
    </StoreHeader>
  );
};
export default Header;

const StoreHeader = styled.div`
  min-height: 96px;

  display: flex;
  align-items: center;
  justify-content: space-between;

  padding: 12px 24px;

  background: #fff;

  border-radius: 12px;

  box-shadow: 0 2px 12px rgba(31, 45, 61, 0.06);
`;

const StoreInfo = styled.div`
  display: flex;
  align-items: center;
`;

const StoreIconWrapper = styled.div`
  width: 56px;
  height: 56px;

  display: flex;
  align-items: center;
  justify-content: center;

  background: ${Colors.primary[1]};
  border-radius: 8px;
`;

const StoreMainInfo = styled.div`
  margin-left: 20px;
`;

const StoreNameRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const EditButton = styled.button`
  width: 26px;
  height: 26px;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 0;

  border: 0;
  background: transparent;

  cursor: pointer;
`;

const StoreContact = styled.div`
  display: flex;
  align-items: center;

  height: 52px;
`;

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  color: #344054;
`;

const ContactDivider = styled.div`
  width: 1px;
  height: 32px;

  margin: 0 22px;

  background: #e3e7ee;
`;

const Address = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 2px;

  color: #344054;

  font-size: 14px;
  line-height: 19px;
`;
